<template>
  <div class="content-wrapper">
    <SendGiftMenu header="Send Gifts" />
    <!--  Backend Not Pushed  -->
    <!--    <NoGiftAvailable-->
    <!--      v-if="remainingShipments === 0 && availableAdditionalOrders === 0"-->
    <!--    />-->
    <!--  Backend Not Pushed  -->
    <ProductGallery />
    <BundlesGallery />
  </div>
</template>

<script>
import { layouts, storeModules } from '../../helpers'
import SendGiftMenu from '@/components/SendGiftMenu'
import store from '../../store'
import NoGiftAvailable from '@/components/Notification/SwagStore/NoGiftsAvailable.vue'
import { mapState } from 'vuex'

export default {
  name: 'GiftList',
  data() {
    return {
      isLoading: true
    }
  },
  beforeRouteEnter(routeTo, routeFrom, next) {
    if (
      store.state.team.team.teamModuleNames.includes(storeModules.swag_store)
    ) {
      next()
    } else if (
      store.state.team.team.teamModuleNames.includes(storeModules.project)
    ) {
      next({ name: 'Projects' })
    }
  },
  components: {
    ProductGallery: () => import('./ProductGallery'),
    BundlesGallery: () => import('./BundlesGallery'),
    SendGiftMenu,
    NoGiftAvailable,
  },
  computed: {
    ...mapState({
      remainingShipments: (state) => state.report.remainingShipments,
      availableAdditionalOrders: (state) =>
        state.team.team.availableAdditionalOrders,
    }),
  },
  created() {
    Promise.all([
      this.$store.dispatch('layout/setPageLayout', layouts.PAIGE_DASHBOARD),
      this.$store.dispatch('report/avarageShipments')
    ]).then(() => {
      this.isLoading = false
    })
  },
}
</script>

<style scoped lang="scss">
@import '@/global.scss';

@media screen and (max-width: 1500px) and (min-width: 350px) {
  .content-wrapper {
    padding-right: 0;
  }
}
</style>
